import type { ReactNode } from 'react';

export const symbol_2d: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M313-410v-53h87q14.02 0 23.51-9.49Q433-481.98 433-496v-70q0-14.45-9.49-24.22Q414.02-600 400-600H288q-10.83 0-17.92 7.12-7.08 7.11-7.08 18 0 10.88 7.08 17.88 7.09 7 17.92 7h95v54h-87q-14.02 0-23.51 9.49Q263-477.02 263-463v78q0 10.83 7.08 17.92Q277.17-360 288-360h120q10.83 0 17.92-7.12 7.08-7.11 7.08-18 0-10.88-7.08-17.88-7.09-7-17.92-7h-95Zm232 50h123q18.75 0 31.88-13.13Q713-386.25 713-405v-150q0-18.75-13.12-31.88Q686.75-600 668-600H545q-10.83 0-17.92 7.08Q520-585.83 520-575v190q0 10.83 7.08 17.92Q534.17-360 545-360Zm25-50v-140h93v140h-93ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z"
		/>
	</svg>
);
